/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_4_Item_DamageInputs */

const en_terms_section_4_item_damage = /** @type {(inputs: Terms_Section_4_Item_DamageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not use it in a way that could damage, disable or degrade it.`)
};

const lv_terms_section_4_item_damage = /** @type {(inputs: Terms_Section_4_Item_DamageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nelietot to veidā, kas varētu to sabojāt, apturēt vai pasliktināt tās darbību.`)
};

/**
* | output |
* | --- |
* | "Not use it in a way that could damage, disable or degrade it." |
*
* @param {Terms_Section_4_Item_DamageInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_4_item_damage = /** @type {((inputs?: Terms_Section_4_Item_DamageInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_4_Item_DamageInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_4_item_damage(inputs)
	return en_terms_section_4_item_damage(inputs)
});